import { Alert, AlertProps } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Flex from '../Flex';

export interface NotAllowedProps extends React.PropsWithChildren, AlertProps {
}

export function NotAllowed({ children, message, ...alert }: NotAllowedProps) {
  return (
    <Flex className="my-2" direction="column">
      <Alert
        {...alert}
        className="p-4"
        message={
          <Flex align="center" direction="row" className="w-full h-full">
            <ExclamationCircleOutlined className="text-xl items-start mb-auto leading-[1.25]" />
            {(
              <Flex className="w-full text-base leading-[1.25]">
                {children ?? message}
              </Flex>
            )}
          </Flex>
        } />
    </Flex>
  );
}

export default NotAllowed;
